import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import {getFHInfo, getFSInfo, putFH, putFS} from "../../api/apiClient";
import ComboSeriusStatus from "../../components/inputs/ComboSeriusStatus";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import DatePicker from "react-date-picker";
import Moment from "moment";

const FaultMgmt = ({
                     propRcptNo = '',
                     propLc = '',
                     hClose
                   }) => {

  const [stDetailInfo, setDetailInfo] = useState({
    cause_id: '',         // 장애아이디
    lc: '',              // 발생위치
    managt_dt_bun: '00',     // 조치일(분)
    managt_dt_date: '',   // 조치일(날짜)
    managt_dt_si: '00',      // 조치일(시간)
    maner: '',           // 조치자
    recovry_message: '',  // 복구처리 메세지
    recovry_term: '',     // 복구기한
    sttus: "0",          // 상태
    ytrtd_resn: '',     // 미복구사유
    rcptNo: propRcptNo
  });

  // useEffect(() => {
  //   // console.log(stDetailInfo);
  // }, [stDetailInfo]);

  useEffect(() => {
    console.log(propRcptNo);
  }, [propRcptNo]);

  /* 장애현황 목록 갱신 */
  const updateDetail = () => {
    getFHInfo(propRcptNo)
        .then((res) => {
              console.log(res);
              if (res.data.data !== undefined) {
                setDetailInfo(res.data.data);
              }
            }
        );
  };

  useEffect(() => {
    updateDetail();
  }, [])

  const onChangeInfo = (name, value) => {
    //console.log(name, value);

    let newInfo = {...stDetailInfo};
    newInfo[name] = value;
    //console.log(`${name} : ${value}`);

    setDetailInfo(newInfo);
    // console.log(newInfo);
  }

  const onChangeDate = (name, value) => {
    let newInfo = {...stDetailInfo};
    newInfo[name] = Moment(value).format('YYYY-MM-DD');
    setDetailInfo(newInfo);
  };

  const onSubmit = () => {
    console.log(stDetailInfo);
    let detailInfo = stDetailInfo;

    /*if (!stDetailInfo.sttus) {
      Swal.fire(
          '장애상태는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }*/

    if (!detailInfo.sttus === '0' || !detailInfo.sttus === 0) {
      Swal.fire(
          '장애상태는 복구를 선택 하세요.',
          '',
          'error'
      );
      return;
    }

    if (!detailInfo.managt_dt_si) {
      // console.log("stDetailInfo.managt_dt_si : " + stDetailInfo.managt_dt_si);
      detailInfo.managt_dt_si = "00";
    }
    if (!detailInfo.managt_dt_bun) {
      // console.log("stDetailInfo.managt_dt_bun : " + stDetailInfo.managt_dt_bun);
      detailInfo.managt_dt_bun = "00";
    }

    putFH(detailInfo)
        .then((res) => {
          let data = res.data;
          Swal.fire(
              '정상적으로 처리 되었습니다!',
              '',
              'success'
          );
          hClose();
        })
        .catch(err => {
          console.log(detailInfo);
          // 에러 처리
          //console.log(err.response.data.message);
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  };

  const minutes = () => {
    const result = [];
    for (let i = 0; i < 60; i++) {
      if (i < 10) {
        result.push(<option key={'0' + i} value={'0' + i}>{'0' + i}분</option>);
        continue;
      }
      result.push(<option key={i} value={i}>{i}분</option>);
    }
    return result;
  };

  /*  const [managtDtDate, onChangeManagtDtDate] = useState('');

    useEffect(() => {
      if (managtDtDate !== '') {
        onChangeDate('managt_dt_date', managtDtDate);
      }
    }, [managtDtDate]);*/

  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={12} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'gateway-register-form py-3'}
                      id={'gatewayRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <Form.Group as={Row} controlId="formGtwyId">
                              <Form.Label column md={3} className={'label text-end'}>
                                장애등급
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.serius_level_nm || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp1Addr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                발생시간
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.ocrn_dt_str || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp2Addr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                장애이벤트
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.cause_nm || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <ComboSeriusStatus
                                propDefaultValue={stDetailInfo.sttus || "0"}
                                propOnChange={(e) => {
                                  onChangeInfo('sttus', e.target.value);
                                }}
                            />
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='forml2IpAddr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                장비유형
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.lc_knd_nm || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end'}>
                                자치구
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.atdrc_nm || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>발생위치
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    disabled={true}
                                    defaultValue={stDetailInfo.mssage || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end'}>
                                조치자
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    // disabled={true}
                                    // defaultValue={stDetailInfo.maner || ''}
                                    value={stDetailInfo.maner || ''}
                                    onChange={(e) => {
                                      onChangeInfo('maner', e.target.value);
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end'}>
                                조치일시
                              </Form.Label>
                              <Col md={5} className={''}>
                                <DatePicker
                                    onChange={(date) => {
                                      onChangeDate('managt_dt_date', date);
                                    }}
                                    value={stDetailInfo.managt_dt_date ? new Date(stDetailInfo.managt_dt_date) : ''}
                                    format={"yyyy-MM-dd"}
                                    className={"datepicker-start w-100 text-center"}
                                    clearIcon={null}
                                    // disabled={stDetailInfo.sttus === "1" || stDetailInfo.sttus === 1}
                                    // readOnly={stDetailInfo.sttus === "0" || stDetailInfo.sttus === 0}
                                    calendarType={'US'}
                                    formatDay={
                                      (locale, date) => new Intl.DateTimeFormat(
                                          'en-US',
                                          {
                                            day: "numeric"
                                          }).format(date)
                                    }
                                />
                                {/*<DatePicker
                                    onChange={(date) => {
                                      // onChangeDate('managt_dt_date', date);
                                      onChangeManagtDtDate(date);
                                    }}
                                    value={stDetailInfo.managt_dt_date ? new Date(stDetailInfo.managt_dt_date) : managtDtDate}
                                    format={"yyyy-MM-dd"}
                                    className={"datepicker-start w-100 text-center"}
                                    disabled={stDetailInfo.sttus === "1" || stDetailInfo.sttus === 1}
                                />*/}
                              </Col>
                              <Col md={2}>
                                <Form.Select
                                    aria-label="Default select example"
                                    className={"input-select time pe-0"}
                                    key={stDetailInfo.managt_dt_si ? stDetailInfo.managt_dt_si : "00"}
                                    defaultValue={stDetailInfo.managt_dt_si ? stDetailInfo.managt_dt_si : "00"}
                                    // onChange={(e) => {
                                    //   propOnChangeEndHour(e.target.value);
                                    // disabled={stDetailInfo.sttus === "1" || stDetailInfo.sttus === 1}
                                    onChange={(e) => {
                                      onChangeInfo('managt_dt_si', e.target.value);
                                    }}
                                >
                                  <option value={"00"}>00시</option>
                                  <option value={"01"}>01시</option>
                                  <option value={"02"}>02시</option>
                                  <option value={"03"}>03시</option>
                                  <option value={"04"}>04시</option>
                                  <option value={"05"}>05시</option>
                                  <option value={"06"}>06시</option>
                                  <option value={"07"}>07시</option>
                                  <option value={"08"}>08시</option>
                                  <option value={"09"}>09시</option>
                                  <option value={"10"}>10시</option>
                                  <option value={"11"}>11시</option>
                                  <option value={"12"}>12시</option>
                                  <option value={"13"}>13시</option>
                                  <option value={"14"}>14시</option>
                                  <option value={"15"}>15시</option>
                                  <option value={"16"}>16시</option>
                                  <option value={"17"}>17시</option>
                                  <option value={"18"}>18시</option>
                                  <option value={"19"}>19시</option>
                                  <option value={"20"}>20시</option>
                                  <option value={"21"}>21시</option>
                                  <option value={"22"}>22시</option>
                                  <option value={"23"}>23시</option>
                                </Form.Select>
                              </Col>
                              <Col md={2}>
                                <Form.Select
                                    aria-label="Default select example"
                                    className={"input-select time pe-0"}
                                    key={stDetailInfo.managt_dt_bun ? stDetailInfo.managt_dt_bun : "00"}
                                    defaultValue={stDetailInfo.managt_dt_bun ? stDetailInfo.managt_dt_bun : "00"}
                                    // onChange={(e) => {
                                    //   propOnChangeEndHour(e.target.value);
                                    // disabled={stDetailInfo.sttus === "1" || stDetailInfo.sttus === 1}
                                    onChange={(e) => {
                                      onChangeInfo('managt_dt_bun', e.target.value);
                                    }}
                                >
                                  {minutes()}
                                </Form.Select>
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end'}>
                                조치결과
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    as="textarea"
                                    style={{height: '100px'}}
                                    className={'input text-white'}
                                    // defaultValue={stDetailInfo.recovry_message || ''}
                                    value={stDetailInfo.recovry_message || ''}
                                    onChange={(e) => {
                                      console.log(e.target.value);
                                      onChangeInfo('recovry_message', e.target.value);
                                    }}
                                />
                                {/*<Form.Control*/}
                                {/*    type='text'*/}
                                {/*    className={'input text-white'}*/}
                                {/*    // disabled={true}*/}
                                {/*    defaultValue={stDetailInfo.recovry_message || ''}*/}
                                {/*    onChange={(e) => {*/}
                                {/*      onChangeInfo('recovry_message', e.target.value);*/}
                                {/*    }}*/}
                                {/*/>*/}
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='date'>
                              <Form.Label column md={3} className={'label text-end'}>
                                복구기한
                              </Form.Label>
                              <Col md={5} className={''}>
                                <DatePicker
                                    onChange={(date) => {
                                      onChangeInfo('recovry_term', Moment(date).format('YYYY-MM-DD'));
                                    }}
                                    value={stDetailInfo.recovry_term ? new Date(stDetailInfo.recovry_term) : ''}
                                    format={"yyyy-MM-dd"}
                                    className={"datepicker-start w-100 text-center"}
                                    clearIcon={null}
                                    calendarType={'US'}
                                    formatDay={
                                      (locale, date) => new Intl.DateTimeFormat(
                                          'en-US',
                                          {
                                            day: "numeric"
                                          }).format(date)
                                    }
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label text-end'}>
                                미복구사유
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    as="textarea"
                                    style={{height: '100px'}}
                                    className={'input text-white'}
                                    // defaultValue={stDetailInfo.ytrtd_resn || ''}
                                    value={stDetailInfo.ytrtd_resn || ''}
                                    key={stDetailInfo.ytrtdResn || ''}
                                    onChange={(e) => {
                                      onChangeInfo('ytrtd_resn', e.target.value);
                                    }}
                                />
                                {/*<Form.Control*/}
                                {/*    type='text'*/}
                                {/*    className={'input text-white'}*/}
                                {/*    // disabled={true}*/}
                                {/*    defaultValue={stDetailInfo.ytrtd_resn || ''}*/}
                                {/*    onChange={(e) => {*/}
                                {/*      onChangeInfo('ytrtd_resn', e.target.value);*/}
                                {/*    }}*/}
                                {/*/>*/}
                              </Col>
                            </Form.Group>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>

            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn save-btn w-100'}
                        onClick={onSubmit}
                >저장</Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
              </Col>
            </Row>

          </Col>
        </Row>
      </Container>
  );
};

export default FaultMgmt;
